import { Injectable } from '@angular/core';
// tslint:disable: no-unused-expression
/**
 * èåç¶ææå¡
 * @scope FormModule
 */
@Injectable()
class MenuStateService {
    private readonly COMMAND_SERVICE_LINK_STORAGE_KEY = 'COMMAND_SERVICE_LINK_STORAGE_KEY';
    private getState() {
        const data = !!sessionStorage && sessionStorage.getItem(this.COMMAND_SERVICE_LINK_STORAGE_KEY) || null;
        if (!!data) {
            return JSON.parse(data);
        }
        return {};
    }
    private setState(links) {
        !!sessionStorage && sessionStorage.setItem(this.COMMAND_SERVICE_LINK_STORAGE_KEY, JSON.stringify(links));
    }
    public addMenuState(parentMenuId: string, childMenuId: string, status: boolean = true) {
        if (!childMenuId) {
            return;
        }
        const state = this.getState();
        const isParentExist = !!state && state.hasOwnProperty(parentMenuId);
        const childItem = { id: childMenuId, status };
        if (isParentExist) {
            const parent = state[parentMenuId];
            const isChildItemExist = parent.find(item => item.id === childMenuId);
            if (!isChildItemExist) {
                state[parentMenuId].push(childItem);
            }
        } else {
            state[parentMenuId] = [childItem];
        }
        this.setState(state);
    }
    public getMenuState(parentMenuId: string, childMenuId?: string) {
        const state = this.getState();
        if (state === null) {
            return null;
        }
        const isParentExist = state.hasOwnProperty(parentMenuId);
        if (!isParentExist) {
            return null;
        }
        const parentMenu = state[parentMenuId];
        const childMenu = parentMenu.filter(item => item.status === true);
        if (typeof childMenuId === 'undefined' || childMenuId.length < 1) {
            return childMenu;
        }
        return parentMenu.filter(item => item.status && item.id === childMenuId);
    }
    public updateMenuState(childMenuId: string, status: boolean) {
        const state = this.getState();
        if (state === null) {
            return;
        }
        Object.keys(state).forEach(key => {
            const childMenu = state[key].find(item => item.id === childMenuId);
            if (!!childMenu) {
                childMenu.status = status;
            }
        });
        this.setState(state);
    }
    public removeMenu(menuId: string) {
        this.removeParentMenu(menuId);
        this.removeChildMenu(menuId);
    }
    private removeParentMenu(menuId: string) {
        const state = this.getState();
        if (state === null) {
            return null;
        }
        Object.keys(state).forEach(item => {
            if (item === menuId && state[menuId].length < 1) {
                delete state[item];
            }
        });
        this.setState(state);
    }
    private removeChildMenu(menuId: string) {
        const state = this.getState();
        if (state === null) {
            return;
        }
        Object.keys(state).forEach(parentMenuId => {
            const childMenus = state[parentMenuId];
            if (childMenus && childMenus.length > 0) {
                childMenus.forEach((child, index) => {
                    if (child.id === menuId) {
                        childMenus.splice(index, 1);
                    }
                });
            }
        });
        this.setState(state);
    }
}

export { MenuStateService };
